import { Option } from "@/components/forms/inputs/Autocomplete/types";

export const defaultRepeaterConverter = ({
    value,
    alwaysArray,
}: {
    value: { id?: string | Option | unknown; [key: string]: unknown }[];
    /**
     * Ska en tom array skickas om value är undefined/null?
     */
    alwaysArray?: boolean;
}) => {
    if (alwaysArray && !value) {
        return [];
    }

    return value.map(({ id }): unknown => {
        if (typeof id === "object") {
            return (id as Option).value;
        }

        return id;
    });
};

type InputNameAndValue = {
    [key: string]: string | Option | unknown;
};

/**
 * Denna funktion fungerar likadant som defaultRepeaterConverter men dess objekt properties hanteras dynamiskt,
 * dvs oavsett namn, och inkluderar samtliga properties om det finns fler än 1.
 * Varje property med ett objekt, byts ut till dess value
 *
 * Exempel input:
 * [
 *  {
 *   	fran: { label: 'Th1', value: '10'}      <-- Option objekt
 *	    till: { label: 'Th11', value: '18'}
 *  },
 *  {
 *   	fran: { label: 'C1', value: '2'}
 *	    till: { label: 'C3', value: '4'}
 *  },
 * ]
 *
 * Output:
 *
 *  [
 *  {
 *   	fran: '10'
 *	    till: '18'
 *  },
 *  {
 *   	fran: '2'
 *	    till: '4'
 *  },
 * ]
 *
 * @param value Array med objekt innehållande properties med namn och value i form av select-option objekt
 * @returns
 */
export const dynamicPropsRepeaterConverter = ({ value }: { value: InputNameAndValue[] }) => {
    if (!value || !value.length) {
        return [];
    }

    const data: InputNameAndValue[] = [];

    value.forEach((item) => {
        const newItem = { ...item };

        Object.keys(item).forEach((key) => {
            if (typeof item[key] === "object" && !Array.isArray(item[key])) {
                newItem[key] = (newItem[key] as Option)?.value;
            }
        });
        data.push(newItem);
    });

    return data;
};

export const addMore = (data: any) => {
    return [...(data ?? []), {}];
};

type ICurrentValue<T = Record<string, unknown>> = T[] | undefined;

/**
 * Lägg till en ny tom rad, om det ska vara minimum 1 rad och det inte finns några rader
 */
export const addMinimumRows = (currentValue?: ICurrentValue) => {
    if (!currentValue || currentValue?.length === 0) {
        return addMore(currentValue);
    }
    return currentValue;
};
